import React, { useState } from "react"

//service
import { env, IENVIRONMENT } from "../../services/env.service"
import HTTP from "../../services/http.service";


const DevControls = () => {
    const [showDevControls, setShowDevControls] = useState<boolean>(false);


    if (!showDevControls) {        
        return (
            <div style={{ position: 'fixed', bottom: 0, right: 0, padding: '16px' }}>
                <button onClick={() => {setShowDevControls(true)}}>change environment details</button>
            </div>
        )  
    }

    return (
        <div style={{ position: 'fixed', bottom: 0, right: 0, padding: '16px' }}>
            <div style={{display:'flex', flexDirection: 'column', gap: '16px', marginBottom: '8px'}}>
                <div style={{display: 'flex', gap: '16px'}}>
                    <label> select environment</label>
                    <select value={env.ENVIRONMENT} onChange={(e) => env.ENVIRONMENT = e.target.value as IENVIRONMENT}>
                        <option value={undefined}> none selected</option>
                        <option value={IENVIRONMENT.QA}>QA</option>
                        <option value={IENVIRONMENT.PRODUCTION}>Production</option>
                        <option value={IENVIRONMENT.FEATURE}>Feature</option>
                        <option value={IENVIRONMENT.LOCAL}>Local</option>
                    </select>
                </div>
                <div style={{display: 'flex', gap: '16px'}}>
                    <label>enter feature name</label>
                    <input type='text' value={env.FEATURENAME} onChange={(e) => env.FEATURENAME = e.target.value} />
                </div>
            </div>
            <div style={{display:'flex', justifyContent: 'flex-end', gap: '16px'}}>
                <button onClick={() => HTTP.get('/api/organization/tab/exists').catch(() => {})}>test</button>
                <button onClick={() => {setShowDevControls(false)}}>hide dev controls</button>
            </div>
        </div>
    )
}

export default DevControls